import {
  createPrivacyController,
  type PrivacyController,
  type PrivacyControllerOptions,
} from "../controller.js";
import {
  initializeCookieConsentAdapter,
  syncCookieConsent,
} from "../cookieconsent-adapter.js";
import { mountInlinePrivacyControls } from "../inline-controls.js";
import type { SitePrivacyConfig } from "../types.js";

export { loadDeclaredScript } from "../script-loader.js";

export async function setupPriorConsentController(
  config: SitePrivacyConfig,
  options?: PrivacyControllerOptions,
) {
  if (config.mode !== "prior-consent") {
    throw new Error("Global entry requires prior-consent mode");
  }
  const controller = createPrivacyController(config, options);
  await initializeCookieConsentAdapter(controller);
  const snapshot = await controller.initialize();
  syncCookieConsent(snapshot);
  const stopSync = controller.subscribe(syncCookieConsent);
  return {
    controller,
    destroy() {
      stopSync();
      controller.destroy();
    },
  };
}

export function mountPriorConsentControls(
  controller: PrivacyController,
  root: HTMLElement,
) {
  if (controller.config.mode !== "prior-consent") {
    throw new Error("Prior-consent controls require prior-consent mode");
  }
  return mountInlinePrivacyControls({ root, controller });
}

export async function setupPriorConsentControls(
  config: SitePrivacyConfig,
  root: HTMLElement,
  options?: PrivacyControllerOptions,
) {
  const setup = await setupPriorConsentController(config, options);
  const { controller } = setup;
  const unmount = mountPriorConsentControls(controller, root);
  return { ...setup, unmount };
}
